<gc-location-card [address]="draft().location"
                  [position]="draft().coordinates"
                  [showShare]="showShare()"
                  (edit)="editLocation()"></gc-location-card>
